import { createAddJackpotModel } from 'features/add-jackpot';
import { createBlockJackpotModel } from 'features/block-jackpot';
import { createDeleteJackpotModel } from 'features/delete-jackpot';
import { createEditJackpotModel } from 'features/edit-jackpot';
import { createUnblockJackpotModel } from 'features/unblock-jackpot';
import { accountTreeModel } from 'entities/account';
import { createJackpotRegistryModel } from 'entities/jackpot';
import { accountPageModel } from './account-page-model';

const addJackpotModel = createAddJackpotModel();

const deleteJackpotModel = createDeleteJackpotModel();

const editJackpotModel = createEditJackpotModel();

const blockJackpotModel = createBlockJackpotModel();

const unblockJackpotModel = createUnblockJackpotModel();

const jackpotRegistryModel = createJackpotRegistryModel({
	$accountId: accountPageModel.$accountId,
	$currencies: accountTreeModel.$currencies,
	onDelete: [deleteJackpotModel.mutation.finished.success],
	onUpdate: [
		addJackpotModel.addJackpotMutation.finished.success,
		editJackpotModel.editJackpotMutation.finished.success,
		blockJackpotModel.mutation.finished.success,
		unblockJackpotModel.mutation.finished.success,
		accountPageModel.accountIdSet,
	],
});

export const accountPageJackpotModel = {
	jackpotRegistryModel,
	addJackpotModel,
	deleteJackpotModel,
	editJackpotModel,
	blockJackpotModel,
	unblockJackpotModel,
};
